module.exports = function () {
  return {
    restrict: 'EA',
    replace: true,
    template: require('raw!templates/footer.html'),
    controller: controller
  }
}

function controller($scope, $state, store, $window, contentful, $timeout) {
  var vm = this;
  if (window.location.hash && $(window.location.hash).length) {
    $(window.location.hash).modal('show');
  }

  contentful.entries('content_type=footer').then(function (res) {
    $scope.footer = res.data.items[0];

  });

}


// WEBPACK FOOTER //
// ./components/directives/footer.js